import { QUERY_KEYS } from "@forwardflow/helpers/utils/constants";
import SubscriptionService from "@forwardflow/services/SubscriptionService";
import { PaginationQueryParams } from "@forwardflow/types";
import useSWR from "swr";
import { gated } from "@forwardflow/utils/sandbox";

export const useSubscriptionPackageLists = (
  queryParams: PaginationQueryParams,
) => {
  const response = useSWR(
    gated([QUERY_KEYS.SUBSCRIPTION_PACKAGES, { ...queryParams }]),
    () => SubscriptionService.getSubscriptionLists(queryParams)
  );
  return {
    ...response,
  };
};

